module.exports = __webpack_public_path__ + "static/media/065.b285843e.jpg";